import { ScanField } from "@overmap-ai/forms"
import type { ReactNode } from "react"

import {
	NullableStringEqualsFilterModifier,
	NullableStringNotEqualsFilterModifier,
	StringExcludesFilterModifier,
	StringIncludesFilterModifier,
} from "../../modifiers"
import { BaseFilterDef, createFilterModifierConfig, type FilterDefRenderProps } from "../BaseFilterDef"
import { ScanFieldFilterCell } from "./ScanFieldFilterCell"

type ScanFieldValue = string | null
type ScanFilterValue = string | null

export class ScanFieldFilterDef extends BaseFilterDef<ScanFieldValue, ScanFilterValue> {
	readonly id: string
	readonly defaultFilterValue: ScanFilterValue | undefined = undefined
	readonly defaultFilterModifier: keyof typeof this.modifiers = "equals"

	readonly field: ScanField

	constructor(field: ScanField) {
		super()
		this.field = field
		this.id = field.id
	}

	readonly modifiers = {
		equals: createFilterModifierConfig({
			modifier: NullableStringEqualsFilterModifier,
			isValueValid: (_value: ScanFieldValue): _value is string => true,
			isFilterValueValid: (_filterValue: ScanFilterValue): _filterValue is string | null => true,
		}),
		notEquals: createFilterModifierConfig({
			modifier: NullableStringNotEqualsFilterModifier,
			isValueValid: (value: ScanFieldValue): value is string => value !== null,
			isFilterValueValid: (_filterValue: ScanFilterValue): _filterValue is string | null => true,
		}),
		includes: createFilterModifierConfig({
			modifier: StringIncludesFilterModifier,
			isValueValid: (value: ScanFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: ScanFilterValue): filterValue is string => filterValue !== null,
		}),
		excludes: createFilterModifierConfig({
			modifier: StringExcludesFilterModifier,
			isValueValid: (value: ScanFieldValue): value is string => value !== null,
			isFilterValueValid: (filterValue: ScanFilterValue): filterValue is string => filterValue !== null,
		}),
	}

	render(props: FilterDefRenderProps<ScanFieldFilterDef>): ReactNode {
		return <ScanFieldFilterCell key={props.filter.id} field={this.field} {...props} />
	}
}
